export interface TermsOfServiceAcceptanceDto {
  /**
   * format: uuid
   */
  id: string;

  termsVersion: string;
  /**
   * format: date-time
   */
  acceptedAt: string;

  ipAddress?: string;
}
